import { useAuthStore } from "@/lib/auth-store";

/** Is de ingelogde gebruiker beheerder (rol admin)? Zelfde grens als `AdminRoute`. */
export function useBeheerder(): boolean {
  return useAuthStore((s) => s.gebruiker?.rol === "admin");
}
